// Preprocess legacy Quill (v1) HTML so Tiptap parses it faithfully during the edit-triggered
// v1 → v2 migration (we feed this to the editor's `content`, then saving re-serializes as JSON).
//
// Quill encodes block alignment as `ql-align-*` classes, but Tiptap's TextAlign extension only
// reads an inline `text-align` style — so translate the classes to inline styles before parsing,
// otherwise alignment silently drops. (See the SOP tiptap-v2 migration design, §7 fidelity notes.)
//
// Not handled: Quill `ql-indent-*` has no Tiptap paragraph-indent equivalent and is dropped.
// Video embeds survive via the Video node's parseHTML (bare <youtube>/<vimeo> tags) and need no
// preprocessing here.
const QL_ALIGN = {
  'ql-align-center': 'center',
  'ql-align-right': 'right',
  'ql-align-justify': 'justify',
}

export function prepareLegacyHtml(html) {
  if (!html || typeof html !== 'string' || !html.includes('ql-align-')) return html

  const doc = new DOMParser().parseFromString(html, 'text/html')
  doc.querySelectorAll('[class*="ql-align-"]').forEach((el) => {
    Object.entries(QL_ALIGN).forEach(([cls, value]) => {
      if (el.classList.contains(cls)) {
        el.style.textAlign = value
        el.classList.remove(cls)
      }
    })
  })

  return doc.body.innerHTML
}
